import { Middleware } from 'redux';

import {
  successCreateBoard,
  successDestroyBoard,
  successReadBoardsByGroup,
  successReadBoardsDiff,
  successUpdateBoard
} from '../actions/board';
import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import DeleteBoard from '../apis/DeleteBoard';
import GetBoardsDiff from '../apis/GetBoardsDiff';
import GetBoardsGroup from '../apis/GetBoardsGroup';
import PostBoard from '../apis/PostBoard';
import PutBoard from '../apis/PutBoard';

const MIDDLEWARE = 'boards';

const boardsMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_BOARDS_BY_GROUP':
      readBoardsGroup(store, action);
      break;

    case 'READ_BOARDS_DIFF':
      readBoardsDiff(store, action);
      break;

    case 'CREATE_BOARD':
      createBoard(store, action);
      break;
    case 'UPDATE_BOARD':
      updateBoard(store, action);
      break;

    case 'DESTROY_BOARD':
      destroyBoard(store, action);
      break;
  }
  next(action);
};

const readBoardsGroup = (store: any, action: any) => {
  const METHOD = 'readBoardsGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: GetBoardsGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetBoardsGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        boards => {
          store.dispatch(successReadBoardsByGroup(boards));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readBoardsDiff = (store: any, action: any) => {
  const METHOD = 'readBoardsDiff';
  console.log(MIDDLEWARE + ':' + 'Call API: GetBoardsDiff');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetBoardsDiff();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        boards => {
          store.dispatch(successReadBoardsDiff(boards));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createBoard = (store: any, action: any) => {
  const METHOD = 'createBoard';
  console.log(MIDDLEWARE + ':' + 'Call API: PostBoard');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostBoard();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.board, store.getState().Account).then(
        board => {
          store.dispatch(successCreateBoard(board));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateBoard = (store: any, action: any) => {
  const METHOD = 'updateBoard';
  console.log(MIDDLEWARE + ':' + 'Call API: PutBoard');
  if (store.getState().Network.isInternetAvailable) {
    //    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
    const api = new PutBoard();
    store.dispatch(startCalling(MIDDLEWARE + METHOD));
    api.execute(action.board, store.getState().Account).then(
      board => {
        store.dispatch(successUpdateBoard(board));
        store.dispatch(finishCalling(MIDDLEWARE + METHOD));
      },
      errorMessage => {
        store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
      }
    );
    //    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyBoard = (store: any, action: any) => {
  const METHOD = 'destroyBoard';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteBoard');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteBoard();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.board, store.getState().Account).then(
        board => {
          store.dispatch(successDestroyBoard(action.board));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default boardsMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/boards.ts